var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxboldoriginSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2,5.9h-15c-0.4,0-0.8-0.3-0.8-0.8V2.9c0-0.4,0.3-0.8,0.8-0.8h15c0.4,0,0.8,0.3,0.8,0.8v2.3 C22,5.6,21.6,5.9,21.2,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7,18.7c-0.4,0-0.8-0.4-0.8-0.8V5.7c0-0.4,0.3-0.8,0.8-0.8s0.8,0.4,0.8,0.8v12.1 C20.5,18.3,20.2,18.7,19.7,18.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.7,
    cy: 19.7,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,18.7c-0.4,0-0.8-0.4-0.8-0.8V5.7c0-0.4,0.3-0.8,0.8-0.8s0.8,0.4,0.8,0.8v12.1 C14.5,18.3,14.1,18.7,13.7,18.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 19.7,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,18c-0.1,0-0.1,0-0.2,0C4.3,17.8,4,17.4,4.2,17L7.2,5.2c0.1-0.4,0.5-0.6,0.9-0.5 c0.4,0.1,0.6,0.5,0.5,0.9L5.6,17.4C5.5,17.7,5.2,18,4.9,18z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.4,
    cy: 19.2,
    r: 2.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxboldoriginSearch);
export default __webpack_public_path__ + "static/media/vuesaxboldorigin-search.65ddac0249eee959da5e1fc4bc550d0e.svg";
export { ForwardRef as ReactComponent };